// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var WebhooksSettingsController = function ($rootScope, $scope, Webhook, WebhookTest, Features, $http, gettextCatalog, gettext) {
    $scope.features = Features.features;
    $scope.newWebhook = newWebhook();
    $scope.events = initEvents();
    $scope.webhooks = Webhook.query();

    $http.get("/api/v1/webhooks/allowedAuthTypes").then(function(response) {
        $scope.allowedAuthTypes = response.data;
        setDefaultOption();
    });

    $scope.authTypePretty = Object.freeze({
        "NoAuth": gettextCatalog.getString(gettext("No Authentication")),
        "Basic": gettextCatalog.getString(gettext("HTTP Basic Auth")),
        "Azure": gettextCatalog.getString(gettext("Azure Auth"))
    });

    function setDefaultOption() {
        $scope.newWebhook.Authorization.AuthType = $scope.allowedAuthTypes[0];
    }

    function newWebhook() {
        let hook = new Webhook();
        hook.Events = [];
        hook.Authorization = { };
        setEvents(false);
        return hook;
    }

    function initEvents() {
        let events = { };
        // Creates event properties
        $.each(getCheckboxes(false), function () {
            events[this.name] = false;
        });

        return events;
    }

    function setEvents(set) {
        for (var event in $scope.events)
            if (!set || event !== 'AccountCreated') // Skip selecting deprecated event
                $scope.events[event] = set;
    }

    function getCheckboxes(selected) {
        return selected ? $('#webhookslist [type=checkbox]:checked') : $('#webhookslist [type=checkbox]');
    }

    $scope.anySelected = function () {
        return Object.values($scope.events).indexOf(true) >= 0;
    };

    $scope.isAuthInfoValid = function (authInfo) {
        if (!authInfo) {
            return false;
        }

        if (authInfo.AuthType === 'NoAuth' || authInfo.AuthType === 'Basic') {
            return true;
        }

        if (authInfo.AuthType === 'Azure') {
            return authInfo.Tenant && authInfo.ClientId && authInfo.ClientSecret && authInfo.ApiScope;
        }

        return false;
    }

    $scope.subscribe = function () {
        $scope.newWebhook.Events = [];
        for (var prop in $scope.events) {
            if ($scope.events[prop])
                $scope.newWebhook.Events.push(prop);
        }
        $scope.newWebhook.$save(function () {
            $scope.webhooks.push($scope.newWebhook);
            $scope.newWebhook = newWebhook();
            setDefaultOption();
            $scope.notifySuccess();
        }, function () { console.log($scope.events); });
    };

    $scope.deleteHook = function (id) {
        let hookToDelete = $scope.webhooks.find(function (webhook) { return webhook.Id === id; });
        hookToDelete.$delete({ webhookId: hookToDelete.Id }, function () {
            $scope.webhooks = $scope.webhooks.filter(function (hook) {
                return hook.$$hashKey !== hookToDelete.$$hashKey;
            });
        });
    };

    $scope.testHook = function (webhook) {
        WebhookTest.test(webhook, function (data) {
            if (data.Status) {
                $scope.notifyCustomSuccess("Webhook dispatched successfully");
            } else {
                $rootScope.notifyCustomError(data.ErrorMessage || "Dispatching the webhook failed!");
            }
        });
    };

    $scope.unsuspendHook = function (webhook) {
        Webhook.unsuspend({ webhookId: webhook.Id }, {}, function (updatedHook) {
            webhook.IsSuspended = updatedHook.IsSuspended;
            webhook.CanSelfServiceUnsuspend = updatedHook.CanSelfServiceUnsuspend;
            $scope.notifySuccess();
        });
    };
};
WebhooksSettingsController.$inject = ['$rootScope', '$scope', 'Webhook', 'WebhookTest', 'Features', '$http', 'gettextCatalog', 'gettext'];
